module.exports = __webpack_public_path__ + "8ea82e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram/Storytape-2.jpg
// module id = 1266
// module chunks = 1 4